import { Box, Text, Grid, Spinner } from "grommet";
import { StatusGoodSmall, Download } from "grommet-icons";
import { FrostedGlassBox, Tooltip } from "../components";
import { CERT_COLOURS } from "../constants";
import React, { useState } from "react";
import { useAuth } from "../context";
import { getRedirect } from '../api';


function openPdfFromBase64(base64String) {
    const byteCharacters = atob(base64String);
    const byteNumbers = Array.from(byteCharacters, (char) =>
        char.charCodeAt(0),
    );
    const blob = new Blob([new Uint8Array(byteNumbers)], {
        type: "application/pdf",
    });
    window.open(URL.createObjectURL(blob), "_blank");
}

const CertificateGrid = ({ name, status, link, onClick }) => {
    const [loading, setLoading] = useState(false);

    const handleClick = async () => {
        setLoading(true);
        try {
            await onClick();
        } finally {
            setLoading(false);
        }
    };

    return (
        <Grid 
            rows={["100%"]} 
            columns={["70%", "5%", "5%"]} 
            gap="small" 
            areas={[
                {
                    name: "label", 
                    start: [0, 0],
                    end: [0, 0],
                },
                {
                    name: "status",
                    start: [1, 0],
                    end: [1, 0],
                },
                {
                    name: "link",
                    start: [2, 0],
                    end: [2, 0],
                },
            ]}
        >
            <Box gridArea="label">
                <Text weight="lighter" size="small">
                    {name}
                </Text>
            </Box>
            <Box gridArea="status">
                <Tooltip
                    contents={status}
                    node={
                        <StatusGoodSmall
                            color={CERT_COLOURS[status]}
                        />
                    }
                ></Tooltip>
            </Box>
            {link && (
                <Box gridArea="link">
                    {loading ? (
                        <Spinner size="xsmall" />
                    ) : (
                        <Tooltip
                            contents={"Download"}
                            node={
                                <Download
                                    size="1.2rem"
                                    onClick={handleClick}
                                    color={"white"}
                                    style={{ cursor: "pointer" }}
                                />
                            }
                        ></Tooltip>
                    )}
                </Box>
            )}
        </Grid>
    )
}

const PoolRegistrationSection = ({ swimmingPoolData }) => {
    const { tokens } = useAuth();
    return (
        <>
            {typeof swimmingPoolData === "object" && Object.keys(swimmingPoolData).length > 0 && (
                <FrostedGlassBox>
                    <div class="container">
                        <Box margin={{top: "1rem", left: "1.5rem", bottom: "1rem"}}>
                            <Text margin={{ vertical: "auto" }} size="medium">
                                {`Swimming Pool Registration`}
                            </Text>
                            <Box margin={{ top: "0.5rem" }}></Box>
                            {swimmingPoolData?.state === "NSW" && (() => {
                                const pools = Object.entries(swimmingPoolData).filter(([k]) => k !== 'state' && k !== 'input_address');
                                const showPoolNumber = pools.length > 1;
                                return pools.map(([poolNumber, poolData], index) => (
                                    <React.Fragment key={poolNumber}>
                                        {index > 0 && <Box margin={{ top: "0.5rem" }} />}
                                        {showPoolNumber && (
                                            <Text weight="lighter" size="xsmall" color="light-4" margin={{ bottom: "0.2rem" }}>
                                                {poolNumber}
                                            </Text>
                                        )}
                                        <CertificateGrid
                                            name={"Certificate of Registration"}
                                            status={poolData.registration_certificate}
                                            link={poolData.registration_certificate_url}
                                            onClick={async () => {
                                                await getRedirect(tokens?.idToken, poolData.registration_certificate_url);
                                            }}
                                        />
                                        <Box margin={{ top: "0.2rem" }} />
                                        <CertificateGrid
                                            name={poolData.non_compliance_certificate ? `Certificate of Non-Compliance` : `Certificate of Compliance`}
                                            status={poolData.non_compliance_certificate ?? poolData.compliance_certificate}
                                            link={poolData.non_compliance_certificate_url ?? poolData.compliance_certificate_url}
                                            onClick={async () => {
                                                await getRedirect(tokens?.idToken, poolData.non_compliance_certificate_url ?? poolData.compliance_certificate_url);
                                            }}
                                        />
                                    </React.Fragment>
                                ));
                            })()}
                            {swimmingPoolData?.state === "QLD" && (
                                <CertificateGrid
                                    name={"Safety Certificate"}
                                    status={swimmingPoolData?.safety_certificate}
                                    link={swimmingPoolData?.safety_certificate_url}
                                    onClick={() => {
                                        openPdfFromBase64(
                                            swimmingPoolData?.safety_certificate_url,
                                        );
                                    }}
                                />
                            )}
                        </Box>
                    </div>
                </FrostedGlassBox>
            )}
        </>
    );
};
export { PoolRegistrationSection };
